'use strict';

/* eslint no-inline-comments: off */

const sports = [
  // Extracted from "profile.xls" contained in FitSDKRelease_20.66.00
  'Generic', // 0
  'Running', // 1
  'Cycling', // 2
  'Transition', // 3 (Multi-sport transition)
  'Fitness_equipment', // 4
  'Swimming', // 5
  'Basketball', // 6
  'Soccer', // 7
  'Tennis', // 8
  'American_football', // 9
  'Training', // 10
  'Walking', // 11
  'Cross_country_skiing', // 12
  'Alpine_skiing', // 13
  'Snowboarding', // 14
  'Rowing', // 15
  'Mountaineering', // 16
  'Hiking', // 17
  'Multisport', // 18
  'Paddling', // 19
  'Flying', // 20
  'E_biking', // 21
  'Motorcycling', // 22
  'Boating', // 23
  'Driving', // 24
  'Golf', // 25
  'Hang_gliding', // 26
  'Horseback_riding', // 27
  'Hunting', // 28
  'Fishing', // 29
  'Inline_skating', // 30
  'Rock_climbing', // 31
  'Sailing', // 32
  'Ice_skating', // 33
  'Sky_diving', // 34
  'Snowshoeing', // 35
  'Snowmobiling', // 36
  'Stand_up_paddleboarding', // 37
  'Surfing', // 38
  'Wakeboarding', // 39
  'Water_skiing', // 40
  'Kayaking', // 41
  'Rafting', // 42
  'Windsurfing', // 43
  'Kitesurfing', // 44
  'Tactical', // 45
  'Jumpmaster', // 46
  'Boxing', // 47
  'Floor_climbing', // 48
  'Biking', // 49
  'training', // 50
  'All', // 254 (All is for goals only to include all sports)

  // After this line these are sub_sport type from FitSDKRelease_20.66.00
  'Generic', // 52
  'Treadmill', // 53
  'Street', // 54
  'Trail', // 55
  'Track', // 56
  'Spin', // 57
  'Indoor_cycling', // 58
  'Road', // 59
  'Mountain', // 60
  'Downhill', // 61
  'Recumbent', // 62
  'Cyclocross', // 63
  'Hand_cycling', // 64
  'Track_cycling', // 65
  'Indoor_rowing', // 66
  'Elliptical', // 67
  'Stair_climbing', // 68
  'Lap_swimming', // 69
  'Open_water', // 70
  'Flexibility_training', // 71
  'Strength_training', // 72
  'Warm_up', // 73
  'Match', // 74
  'Exercise', // 75
  'Challenge', // 76
  'Indoor_skiing', // 77
  'Cardio_training', // 78
  'Indoor_walking', // 79
  'E_bike_fitness', // 80
  'Bmx', // 81
  'Casual_walking', // 82
  'Speed_walking', // 83
  'Bike_to_run_transition', // 84
  'Run_to_bike_transition', // 85
  'Swim_to_bike_transition', // 86
  'Atv', // 87
  'Motocross', // 88
  'Backcountry', // 89
  'Resort', // 90
  'Rc_drone', // 91
  'Wingsuit', // 92
  'Whitewater', // 93
  'Skate_skiing', // 94
  'Yoga', // 95
  'Pilates', // 96
  'Indoor_running', // 97
  'Gravel_cycling', // 98
  'E_bike_mountain', // 99
  'Commuting', // 100
  'Mixed_surface', // 101
  'Navigate', // 102
  'Track_me', // 103
  'Map', // 104
  'Single_gas_diving', // 105
  'Multi_gas_diving', // 106
  'Gauge_diving', // 107
  'Apnea_diving', // 108
  'Apnea_hunting', // 109
  'Virtual_activity', // 110
  'Obstacle', // 111
];

module.exports = sports;
